<template>

   <mw-dialog  size="large_large" :footerButton="btns" ref="userDialog" :close-on-click-modal="false">
     <el-row class="loadUsers">
       <el-col :span="10">
        <div class="dialog-content">

         <template>
          <el-tabs v-model="activeName" type="card"  @tab-click="handleTabs">
             <el-tab-pane label="全集团" name="first" v-if="showQJT">
               <div :style="{height: dialogHeight + 'px','overflow-y':'scroll' }">
               <mw-tree :url="companyTreeUrl" :async="true" :multiple="true"
                  :expandedFirst="true"  @changed="loadTableTree" ref="deptTreeData" ></mw-tree></div>
             </el-tab-pane>
             <el-tab-pane label="本单位" name="second" v-if="showBDW">
               <div :style="{height: dialogHeight + 'px','overflow-y':'scroll' }">
                <mw-tree :url="deptTreeUrl" :async="true" :multiple="true" :defaultParams="defaultParams"  aliasId="departmentId"
                  :expandedFirst="true"   @changed="loadTableTree2" ref="deptTreeData2"></mw-tree></div>
             </el-tab-pane>
           </el-tabs>
         </template>
        </div>

        <div class="mw-toolbar">成员列表</div>
           <div>
             <el-col :span="8">
             <el-button type="primary" @click="selectAll">全选</el-button>
             <el-button type="primary" @click="unSelect">全不选</el-button>
             </el-col>
             <el-col :span="12" :offset="4">
                <el-input placeholder="用户名" v-model="searchField"  @keyup.enter.native.prevent="searchUser">
                 <el-button v-waves slot="append" type="primary" @click="searchUser">查询</el-button>
               </el-input>
             </el-col>
           </div>
           <div class="mw-toolbar_body" :style="{'margin-top':'50px', height: dialogHeight + 'px' }"  >
              <el-table
               class="mw-table a2"
               :data="users"
               ref="multiple1"
               :show-header="false"
               @row-dblclick="dbAddUser"
                @row-click="rowClick"
                @selection-change="handleSelectionChange"
               style="cursor: pointer;padding-left: 80px">
                <el-table-column type="selection" width="30">

               </el-table-column>
               <el-table-column
                 label="名称" align="left"  width="160">
                 <template slot-scope="scope">
                   {{scope.row.name}}
                 </template>
               </el-table-column>

            </el-table>

           </div>
       </el-col>

       <el-col :span="4">
         <div style="text-align:center">
           <el-button style="display:block;margin:180px 60px 50px 60px" @click="move">选择</el-button>
           <el-button style="display:block;margin:30px 60px;" @click="reset">清空</el-button>
         </div>
       </el-col>

       <el-col :span="10">
          <div class="mw-toolbar">已选择机构(双击移除)</div>
          <div :style="{height: dialogHeight + 'px'}" >
             <el-table
               class="mw-table"
               border
               ref="multipleTable"
               :data="dept"
               :show-header="false"
               tooltip-effect="dark"
               @row-dblclick="dbHandleDept"
               style="cursor: pointer;height:200px">

               <el-table-column
                 type="index"
                 label="序号"
                 width="50"
                 :index="indexMethod">
               </el-table-column>


               <el-table-column

                 label="名称">
                 <template slot-scope="scope">
                   {{scope.row.name}}
                 </template>
               </el-table-column>

               <el-table-column>
                 <template slot-scope="scope">
                   <el-button  type="button" size="small" @click="dbHandleDept(scope.row,scope.$index)"><i class="fa fa-trash-o fa-fw"></i></el-button>
                 </template>
               </el-table-column>
            </el-table>
          </div>

         <div class="mw-toolbar">已选择用户(双击移除)</div>
         <div  :style="{height: (dialogHeight+50) + 'px' }">
           <el-table
             class="mw-table"
             border
             ref="multipleTable"
             :data="deptUsers"
             :show-header="false"
               @row-dblclick="dbHandleUser"
             tooltip-effect="dark"
             style="cursor: pointer">

             <el-table-column
               type="index"
               label="序号"
               width="50"
               :index="indexMethod">
             </el-table-column>


             <el-table-column
               label="名称">
               <template slot-scope="scope">
                 {{scope.row.name}}
               </template>
             </el-table-column>

             <el-table-column>
               <template slot-scope="scope">
                 <el-button  type="button" size="small" @click="dbHandleUser(scope.row,scope.$index)"><i class="fa fa-trash-o fa-fw"></i></el-button>
               </template>
             </el-table-column>

           </el-table>
         </div>

       </el-col>
     </el-row>
   </mw-dialog>

</template>

<script>
 import { mapGetters } from 'vuex';
 export default {
  components: {

  },
  data(){
      return{
       activeName: 'first',
       companyTreeUrl:this.mwUrl('/api/org/listDepartment'),
       deptTreeUrl: this.mwUrl('/api/org/getDepartmentTree'),
       defaultParams:{},
       dialogHeight:200,
       searchField:"",
       btns: [{
         label: '取消',func:this.cancelChoose,type: 'default'
         },{
         label: '确定',func:this. chooseUsersSure
         }
         ],
       multipleSelection:[],
       dept: [],
       users: [],
       members: [],
       deptUsers: [],
       selectId : '',
       selectId2 : ''
      }
  },
  props:{
   checkNodes: {
     type: Object
   },
   showBDW:{
     type:Boolean,
     default:true
   },
   showQJT:{
     type:Boolean,
     default:true
   },
   unitId:{
     type:String,
     default:""
   }
  },
  mounted(){
    let me = this;
      if(!this.showQJT){
        this.activeName = "second";
      }
      this.deptUsers = this.checkNodes.deptUsers;
      this.dept = this.checkNodes.dept;
     if(this.unitId){
        this.defaultParams.rootId = this.unitId;
     }else{

       if(this.expUser && this.expUser.dep){
           if(this.expUser.dep.loginUnit){
             this.defaultParams.rootId  = this.expUser.dep.loginUnit.id;
           }else{
             this.defaultParams.rootId  = this.expUser.dep.loginRootDept.id;
           }
       }
     }
     this.defaultParams.listAble = !this.userInfo.developer;
     me.$nextTick(function(){
       let h = $(document.body).height();
       me.dialogHeight = (h -(h * 0.02) -260)/2;
     });
     MW.test(function(){
       if(me.mwRef("deptTreeData"))
          return true
        return false
     },function(){
       me.mwRef("deptTreeData").$on("dblClick",function(a,b){
         var selected = [];
         selected.push(a);
         me.processSelDeptData(selected);
      })
     },50)
      MW.test(function(){
       if(me.mwRef("deptTreeData2"))
          return true
        return false
     },function(){
       me.mwRef("deptTreeData2").$on("dblClick",function(a,b){
         var selected = [];
         selected.push(a);
         me.processSelDeptData(selected);
      })
     },50)
  },
  computed: {
     ...mapGetters([
       'expUser',
       'userInfo'
     ])
   },
   watch: {

   },
  methods:{
   handleSelectionChange(val) {
     this.multipleSelection = val;
   },
   searchUser(){
     if(!this.searchField){
       this.mwMsg('info','请输入搜索内容');
       return;
     }
     let params = {qcon:this.searchField,start:0,limit:500};
     this.mwApi.org.listDepartmentUserPaging(params).then(res =>{
       this.users = res.result;
     })
   },
   loadTableTree(data){
     let params = {departmentId: data.id};
     this.selectId = data.id;
     this.mwApi.org.listUser(params).then(res =>{
       this.users = res.result;
     })
   },

   loadTableTree2(data){
     let params = {departmentId: data.id};
     this.selectId2 = data.id;
     this.mwApi.org.listUser(params).then(res =>{
       this.users = res.result;
     })
   },

   indexMethod(index) {
     return index + 1;
   },

   cancelChoose(){
     this.mwRef('userDialog').hide();
   },

   chooseUsersSure(){
     this.mwRef('userDialog').hide();
     this.$emit('closeDialog')
   },

   reset(){
     this.dept =[];
     this.deptUsers = [];
   },
   getValue(){
      return {dept: this.dept,users: this.deptUsers};
   },
   rowClick(row, selected){
     this.mwRef('multiple1').toggleRowSelection(row,selected);
   },

   move(){
     if(this.activeName == 'first'){
       let selected = this.mwRef('deptTreeData').getSelected();
       if(selected.length>0){
         this.processSelDeptData(selected);
       }
       if(this.multipleSelection.length >0){
        this.processSelUserData();
       }

     }else{
       let selected = this.mwRef('deptTreeData2').getSelected();
       if(selected.length>0){
         this.processSelDeptData(selected);
       }
       if(this.multipleSelection.length >0){
        this.processSelUserData();
       }
     }
   },
   processSelDeptData(selected){
     if(this.dept.length >0){
       selected.forEach( s =>{
         this.dept.push(s);
       })
       this.dept.forEach( (t,i) =>{
         this.dept.forEach( (d,index) =>{
           if(t.id === d.id && i!= index){
             this.dept.splice(index,1);
             return;
           }
         })
       })
     }
     else{
       this.dept = selected;
     }
   },
   processSelUserData(){
     let me = this;
     let users = this.multipleSelection;
     if(users){
       $.each(users,function(i,u){
         if(!me._hasSelUsers(u.id)){
           me.deptUsers.push(u);
         }
       })
     }
   },
   _hasSelUsers(userId){
     let ret = false;
     $.each(this.deptUsers,function(i,u){
       if(u.id == userId){
         ret = true;
         return;
       }
     })
     return ret;
   },
   dbAddUser(row){
     this.processSelUserData(row);
   },
     dbHandleDept(row){
       //this.dept.splice(row.index,1)
       this.delData(this.dept,row);
     },

     dbHandleUser(row){
       this.delData(this.deptUsers,row);
     },
     delData(datas,row){
       $.each(datas,function(i,d){
         if(d.id==row.id){
           datas.splice(i,1);
           return;
         }
       })
     },
     selectAll(){
       this.users.forEach(item =>{
         this.rowClick(item,true)
       })
     },
     unSelect(){
       this.users.forEach(item =>{
         this.rowClick(item,false)
       })
     },
     handleTabs(data){
       if(data.label === '全集团'){
         if(this.selectId){
         this.loadTableTree({id : this.selectId})}
         else{
           this.users =[]
         }
       }else{
         if(this.selectId2){
          this.loadTableTree2({id : this.selectId2})
         }else{
           this.users = []
         }
       }
     },
     show(){
       this.mwRef('userDialog').show();
     }
  }

 }
</script>
<style rel="stylesheet/scss" lang="scss">
.loadUsers {
 .el-table__body-wrapper{
   height: calc(100% - 5px)!important;
 }
 .mw-toolbar{
   height:38px !important;
 }
}
.a2{
 td{
   border: none
 }
}
</style>



// WEBPACK FOOTER //
// src/modules/index/views/systemSet/org/user/loadUsers.vue